import React, { forwardRef } from "react";
import { CardContent } from "@mui/material";

const DSCardContent = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof CardContent>
>((props, ref) => <CardContent ref={ref} {...props} />);

export default DSCardContent;
